import { render, staticRenderFns } from "./BillsFooter.vue?vue&type=template&id=78f2f322&"
import script from "./BillsFooter.vue?vue&type=script&lang=js&"
export * from "./BillsFooter.vue?vue&type=script&lang=js&"
import style0 from "./BillsFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports